(() => {
  'use strict';

  const TRUSTED_ORIGIN = 'https://www.pod.cusprint.com';
  const MESSAGE_TYPE = 'CUSPRINT_IFRAME_CONTENT_HEIGHT';
  const WHEEL_MESSAGE_TYPE = 'CUSPRINT_IFRAME_WHEEL';
  const VIEWPORT_MESSAGE_TYPE = 'CUSPRINT_IFRAME_VIEWPORT';
  const MESSAGE_VERSION = 1;
  const MAX_WHEEL_DELTA = 4000;
  const MIN_IFRAME_TOP = -1000000;
  const MAX_IFRAME_TOP = 1000000;
  const MIN_VIEWPORT_HEIGHT = 1;
  const MAX_VIEWPORT_HEIGHT = 20000;
  const originalInlineMinimums = new WeakMap();
  let viewportFrameId = null;

  const getOriginalInlineMinimum = (iframe) => {
    if (originalInlineMinimums.has(iframe)) {
      return originalInlineMinimums.get(iframe);
    }

    const inlineMinimum = iframe.style.minHeight.trim();
    const match = inlineMinimum.match(/^(\d+(?:\.\d+)?)px$/);

    if (!match) {
      return null;
    }

    const minimum = Number.parseFloat(match[1]);

    if (!Number.isFinite(minimum) || minimum < 0) {
      return null;
    }

    originalInlineMinimums.set(iframe, minimum);
    return minimum;
  };

  const initialIframe = document.getElementById('cuswebIframe');

  if (initialIframe) {
    getOriginalInlineMinimum(initialIframe);
  }

  const sendViewportMessage = () => {
    viewportFrameId = null;

    const iframe = document.getElementById('cuswebIframe');

    if (!iframe || !iframe.contentWindow) {
      return;
    }

    const iframeTop = Math.round(iframe.getBoundingClientRect().top);
    const viewportHeight = Math.round(window.innerHeight);

    if (
      !Number.isSafeInteger(iframeTop) ||
      iframeTop < MIN_IFRAME_TOP ||
      iframeTop > MAX_IFRAME_TOP ||
      !Number.isSafeInteger(viewportHeight) ||
      viewportHeight < MIN_VIEWPORT_HEIGHT ||
      viewportHeight > MAX_VIEWPORT_HEIGHT
    ) {
      return;
    }

    iframe.contentWindow.postMessage({
      type: VIEWPORT_MESSAGE_TYPE,
      version: MESSAGE_VERSION,
      iframeTop,
      viewportHeight
    }, TRUSTED_ORIGIN);
  };

  const scheduleViewportMessage = () => {
    if (viewportFrameId !== null) {
      return;
    }

    viewportFrameId = window.requestAnimationFrame(sendViewportMessage);
  };

  window.addEventListener('scroll', scheduleViewportMessage, { passive: true });
  window.addEventListener('resize', scheduleViewportMessage);
  document.addEventListener('load', (event) => {
    const iframe = document.getElementById('cuswebIframe');

    if (iframe && event.target === iframe) {
      scheduleViewportMessage();
    }
  }, true);
  scheduleViewportMessage();

  window.addEventListener('message', (event) => {
    if (event.origin !== TRUSTED_ORIGIN) {
      return;
    }

    const iframe = document.getElementById('cuswebIframe');

    if (!iframe || event.source !== iframe.contentWindow) {
      return;
    }

    const message = event.data;

    if (
      message !== null &&
      typeof message === 'object' &&
      !Array.isArray(message) &&
      message.type === WHEEL_MESSAGE_TYPE &&
      message.version === MESSAGE_VERSION &&
      Number.isFinite(message.deltaY) &&
      message.deltaY !== 0 &&
      Math.abs(message.deltaY) <= MAX_WHEEL_DELTA
    ) {
      window.scrollBy(0, message.deltaY);
      return;
    }

    if (
      message === null ||
      typeof message !== 'object' ||
      Array.isArray(message) ||
      message.type !== MESSAGE_TYPE ||
      message.version !== MESSAGE_VERSION ||
      !Number.isSafeInteger(message.height) ||
      message.height <= 0
    ) {
      return;
    }

    const minimum = getOriginalInlineMinimum(iframe);

    if (minimum === null) {
      return;
    }

    iframe.style.height = `${Math.max(minimum, message.height)}px`;
  });
})();
